import { LocalizedDateTime } from '../../types';

export enum EventActionType {
    setSeriesEvent = 'setSeriesEvent',
}

export type EventAction = SetSeriesEventAction;

export type SetSeriesEventAction = {
    payload: { id: string; start?: LocalizedDateTime; end?: LocalizedDateTime };
    type: EventActionType.setSeriesEvent;
};
